// Empty readonly array
// Can be used to ensure referential equality checks pass
export const EmptyArray: readonly never[] = []